import React, { useRef } from 'react'
import images from '../../app/utlis/image'
import Heading from '../atoms/Heading/Heading'
import AppsRunning from '../molecules/AppsSupportComponents/AppsRunning/AppsRunning'
import ProjectDisplay from '../molecules/ProjectDisplay/ProjectDisplay'
import AppsFaq from '../molecules/AppsFaq/AppsFaq'
import ECommerceIdeaProjects from '../molecules/ECommerceComponents/ECommerceIdeaProject/ECommerceIdeaProjects'
import ReliabilityECommerce from '../molecules/ECommerceComponents/ReliabilityECommerce/ReliabilityECommerce'
import DefaultFooter from '../organisms/DefaultFooter/DefaultFooter'
import { getPageData, useData } from '../../app/helper/functions'
import { motion, useInView } from 'framer-motion'

const ECommercePage = () => {
    const { data } = useData();
    const eCommerceData = getPageData(data, 'eCommercePage');

    // References for animation triggers
    const heroRef = useRef(null);
    const benefitsRef = useRef(null);
    const reliabilityRef = useRef(null);
    const developmentRef = useRef(null);
    const projectsRef = useRef(null);
    const faqRef = useRef(null);
    const ctaRef = useRef(null);

    // Check if sections are in view - removed "once: true" to make animations repeat on scroll
    const heroInView = useInView(heroRef, { once: false, amount: 0.3 });
    const benefitsInView = useInView(benefitsRef, { once: false, amount: 0.3 });
    const reliabilityInView = useInView(reliabilityRef, { once: false, amount: 0.3 });
    const developmentInView = useInView(developmentRef, { once: false, amount: 0.3 });
    const projectsInView = useInView(projectsRef, { once: false, amount: 0.3 });
    const faqInView = useInView(faqRef, { once: false, amount: 0.3 });
    const ctaInView = useInView(ctaRef, { once: false, amount: 0.3 });

    // Animation variants
    const fadeInUp = {
        hidden: { opacity: 0.6, y: 10 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
    };

    const staggerContainer = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.5
            }
        }
    };

    return (
        <div>
            <motion.div
                className='bg-eCommerce-bg bg-center bg-cover bg-no-repeat'
                ref={heroRef}
                initial="hidden"
                animate={heroInView ? "visible" : "hidden"}
                variants={staggerContainer}
            >
                <div className='bg-blackTransparent'>
                    <div className='flex flex-col md:flex-row pr-[10%] pb-8 gap-6 pt-32 md:pt-52'>
                        <motion.img
                            src={images.ECOMMERCEIMAGE}
                            className='z-10 w-full md:w-[50%]'
                            variants={fadeInUp}
                        />
                        <motion.div
                            className='text-white flex flex-col gap-2 relative text-center md:text-end justify-center items-center px-4 md:px-0'
                            variants={fadeInUp}
                        >
                            <div className='font-bold text-4xl md:text-6xl mb-2'>{eCommerceData.title}</div>
                            <div className='font-normal text-xl md:text-2xl'>{eCommerceData.description}</div>
                        </motion.div>
                    </div>
                </div>
            </motion.div>
            <div className='bg-darkGreyPrimary'>
                <motion.div
                    ref={benefitsRef}
                    initial="hidden"
                    animate={benefitsInView ? "visible" : "hidden"}
                    variants={fadeInUp}
                >
                    <Heading className='bg-darkGreyPrimary pt-8 md:pt-12 px-4 md:px-0'
                        subTitle='Benefits of selecting custom E-commerce Development'
                        text="Ready-made e-commerce sites often lack the flexibility and features needed by expanding
                        businesses. Custom development offers a tailored solution for a seamless shopping
                        experience, increased sales, and efficient operations." />
                </motion.div>

                <motion.div
                    ref={reliabilityRef}
                    initial="hidden"
                    animate={reliabilityInView ? "visible" : "hidden"}
                    variants={fadeInUp}
                >
                    <ReliabilityECommerce eCommerceData={eCommerceData} />
                </motion.div>

                <motion.div
                    ref={developmentRef}
                    initial="hidden"
                    animate={developmentInView ? "visible" : "hidden"}
                    variants={fadeInUp}
                >
                    <Heading className='bg-darkGreyPrimary pt-8 md:pt-12 px-4 md:px-0'
                        subTitle='How we develop E-commerce solutions'
                        text="Our method for developing e-commerce platforms is strategic and flexible, ensuring that your
                        solution is secure, can grow, and is tailored to what your business requires." />
                    <ECommerceIdeaProjects eCommerceData={eCommerceData} />
                </motion.div>

                <motion.div
                    ref={projectsRef}
                    initial="hidden"
                    animate={projectsInView ? "visible" : "hidden"}
                    variants={fadeInUp}
                >
                    <ProjectDisplay />
                </motion.div>

                <motion.div
                    ref={faqRef}
                    initial="hidden"
                    animate={faqInView ? "visible" : "hidden"}
                    variants={fadeInUp}
                >
                    <AppsFaq />
                </motion.div>

                <motion.div
                    className='pt-8 md:pt-10 bg-darkGreyPrimary'
                    ref={ctaRef}
                    initial="hidden"
                    animate={ctaInView ? "visible" : "hidden"}
                    variants={fadeInUp}
                >
                    <AppsRunning bgImage='bg-confident-aiHealth-bg' title='Launch your e-commerce development project today.'
                        subtitle='Want to move your business online and boost sales? Our skilled team can create a tailored e-commerce platform that expands with your needs.' />
                </motion.div>
                <DefaultFooter />
            </div>
        </div>
    )
}

export default ECommercePage
